module.exports = __webpack_public_path__ + "img/gz_lc_img.382b403e.png";